export const menuItemStyle = () => {
  return {
    outer:
      'h-thumbnail w-full bg-grey-100 rounded-l-full flex flex-row hover:bg-grey-300 hover:shadow-lg',
    img: 'min-w-thumbnail max-w-thumbnail flex rounded-full',
    inner: 'w-full ml-6 my-auto pr-2',
    name: 'text-lg mb-2',
    desc: 'text-sm italic',
  };
};
